import { Outlet } from "react-router-dom";
import TopNav from "../components/TopNav";

// Layout dùng chung cho TOÀN BỘ site (trừ /deleteaccount) sau khi xoá
// Resshare — không Firebase. TopNav hiện ở MỌI trang (kể cả HappySchool/
// Quiz3) — các trang đó không tự dựng nav riêng nên ẩn đi sẽ mất hẳn
// đường điều hướng qua lại (đã xảy ra thực tế, sửa lại luôn hiện).
const HappySchoolLayoutMain = () => {
  return (
    <>
      <TopNav />
      <Outlet />
    </>
  );
};

export default HappySchoolLayoutMain;
